import React, { SVGProps } from 'react';

const SvgHiTech = (props: SVGProps<SVGSVGElement>) => (
    <svg
        data-name="Hi-Tech"
        width={29.326}
        viewBox="0 0 29.326 29.326"
        {...props}
    >
        <g data-name="Group Main">
            <g data-name="Laptop Base">
                <path
                    data-name="Base Shadow"
                    d="m1 19.5 2 2h23.326l2-2Z"
                    fill="#2b4150"
                />
                <rect
                    data-name="Base Main"
                    x={2.5}
                    y={18}
                    width={24.326}
                    height={3.5}
                    rx={0.5}
                    fill="#3e5564"
                />
                <rect
                    data-name="Keyboard Area"
                    x={4}
                    y={18.5}
                    width={21.326}
                    height={2}
                    rx={0.3}
                    fill="#2b4150"
                />
            </g>
            <g data-name="Laptop Screen">
                <rect
                    data-name="Screen Frame"
                    x={3.5}
                    y={4}
                    width={22.326}
                    height={14.5}
                    rx={0.8}
                    fill="#3e5564"
                />
                <rect
                    data-name="Screen Display"
                    x={5}
                    y={5.5}
                    width={19.326}
                    height={11.5}
                    rx={0.3}
                    fill="#aecafc"
                />
                <rect
                    data-name="Screen Highlight"
                    x={5.5}
                    y={6}
                    width={18.326}
                    height={10.5}
                    rx={0.2}
                    fill="#d8e2f3"
                />
            </g>
            <g data-name="Code Window">
                <rect
                    x={7}
                    y={7.5}
                    width={15.326}
                    height={8}
                    rx={0.3}
                    fill="#12b05e"
                />
                <rect
                    x={7}
                    y={7.5}
                    width={15.326}
                    height={1.5}
                    rx={0.3}
                    fill="#0e8c4a"
                />
                <circle cx={8} cy={8.3} r={0.3} fill="#ff4757" />
                <circle cx={9} cy={8.3} r={0.3} fill="#ffcd27" />
                <circle cx={10} cy={8.3} r={0.3} fill="#12b05e" />
            </g>
            <g data-name="Code Lines" fill="#fed2a4">
                <rect x={8.5} y={10} width={6} height={0.5} rx={0.2} />
                <rect x={8.5} y={11.2} width={8} height={0.5} rx={0.2} />
                <rect x={9.5} y={12.4} width={7} height={0.5} rx={0.2} />
                <rect x={8.5} y={13.6} width={5} height={0.5} rx={0.2} />
            </g>
            <path data-name="Cursor" fill="#ffcd27" d="M16.5 13.6h.6v.5h-.6z" />
            <g data-name="Keyboard Keys" fill="#4a6a7c">
                <rect x={5} y={19} width={1.2} height={1} rx={0.2} />
                <rect x={6.5} y={19} width={1.2} height={1} rx={0.2} />
                <rect x={8} y={19} width={1.2} height={1} rx={0.2} />
                <rect x={9.5} y={19} width={1.2} height={1} rx={0.2} />
                <rect x={11} y={19} width={1.2} height={1} rx={0.2} />
                <rect x={12.5} y={19} width={1.2} height={1} rx={0.2} />
                <rect x={14} y={19} width={1.2} height={1} rx={0.2} />
                <rect x={15.5} y={19} width={1.2} height={1} rx={0.2} />
                <rect x={17} y={19} width={1.2} height={1} rx={0.2} />
                <rect x={18.5} y={19} width={1.2} height={1} rx={0.2} />
                <rect x={20} y={19} width={1.2} height={1} rx={0.2} />
                <rect x={21.5} y={19} width={1.2} height={1} rx={0.2} />
                <rect x={23} y={19} width={1.2} height={1} rx={0.2} />
            </g>
            {'\r\n        {/* Touchpad */}\r\n        '}
            <rect
                data-name="Touchpad"
                x={11.663}
                y={19.8}
                width={6}
                height={1.2}
                rx={0.2}
                fill="#5a7a8c"
            />
            <g data-name="Tech Icons">
                <path
                    d="m1 10 1 1-1 1M28.326 10l-1 1 1 1"
                    stroke="#12b05e"
                    strokeWidth={0.6}
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                {'\r\n            {/* Gear/settings icon */}\r\n            '}
                <circle
                    cx={2.5}
                    cy={14.663}
                    r={1.2}
                    fill="none"
                    stroke="#ffcd27"
                    strokeWidth={0.5}
                />
                <circle cx={2.5} cy={14.663} r={0.4} fill="#ffcd27" />
                {'\r\n            {/* WiFi signal */}\r\n            '}
                <g
                    data-name="WiFi Signal"
                    stroke="#12b05e"
                    strokeWidth={0.5}
                    fill="none"
                    strokeLinecap="round"
                >
                    <path d="M24.5 13q2.326 1 2.326 3" />
                    <path d="M25 14q1.326.8 1.326 2" />
                    <circle cx={26.326} cy={16.2} r={0.3} fill="#12b05e" />
                </g>
                <rect
                    x={1.5}
                    y={6}
                    width={1.5}
                    height={1.5}
                    rx={0.2}
                    fill="#aecafc"
                    opacity={0.7}
                />
                <rect
                    x={26.326}
                    y={6}
                    width={1.5}
                    height={1.5}
                    rx={0.2}
                    fill="#aecafc"
                    opacity={0.7}
                />
            </g>
            <circle
                data-name="Power Light"
                cx={14.663}
                cy={20.5}
                r={0.4}
                fill="#12b05e"
                opacity={0.9}
            />
            <rect
                data-name="Screen Glow"
                x={5}
                y={5.5}
                width={19.326}
                height={2}
                rx={0.3}
                fill="#fff"
                opacity={0.3}
            />
        </g>
    </svg>
);
export default SvgHiTech;
